module.exports = __webpack_public_path__ + "img/scene_party_backlight@2x.b7c873fb.png";